import {
  loadAffiliateConfig,
  loadManifest,
  createAssetLoaderScript,
} from "../../utils/livechat-init-utils";

type LiveChatInit = {
  init: (options: InitOptions) => Promise<void>;
};

type InitOptions = {
  businessUnitId: string;
  environment: string;
};

export const LiveChatInit: LiveChatInit = {
  async init({ businessUnitId, environment }: InitOptions): Promise<void> {
    try {
      window.LiveChat ??= {};
      window.LiveChat.manifest ??= {};
      window.LiveChat.businessUnitId = businessUnitId;
      window.LiveChat.environment = environment;

      const affiliateConfig = await loadAffiliateConfig();
      window.LiveChat = affiliateConfig;

      const manifest = await loadManifest(affiliateConfig.asset_manifest_filename);
      window.LiveChat.manifest = manifest;

      await createAssetLoaderScript(manifest.asset_loader[0]);
    } catch (error: unknown) {
      const errorMessage = `LIVECHAT ERROR: ${(error as Error).message}`;
      console.error(errorMessage);
      window.Sentry?.captureException(errorMessage);
    }
  },
};
